<template>
  <div class="wrapper">
    <h2 class="level">{{ "0" + (index + 1) }}</h2>
    <div class="title">
      <b-skeleton animation="wave" width="100%" height="20px"></b-skeleton>
      <b-skeleton animation="wave" width="70%" height="20px"></b-skeleton>
    </div>
    <div class="details">
      <div class="categories">
        <span class="ico">
          <b-skeleton type="avatar" height="22px" width="22px"></b-skeleton>
        </span>
        <span class="ico">
          <b-skeleton type="avatar" height="22px" width="22px"></b-skeleton>
        </span>
        <span class="ico">
          <b-skeleton type="avatar" height="22px" width="22px"></b-skeleton>
        </span>
        <span class="ico">
          <b-skeleton type="avatar" height="22px" width="22px"></b-skeleton>
        </span>
      </div>
      <span class="read">
        <b-skeleton animation="wave" width="40px"></b-skeleton>
        ∙
        <b-skeleton animation="wave" width="40px"></b-skeleton>
      </span>
      <span class="ico ico-bookmark">
        <b-skeleton type="button" height="20px" width="10px"></b-skeleton>
      </span>
      <span class="ico ico-share">
        <b-skeleton type="button" height="20px" width="10px"></b-skeleton>
      </span>
    </div>
    <div class="profile-badge">
      <b-skeleton type="avatar"></b-skeleton>
      <b-skeleton
        animation="wave"
        width="70px"
        height="12px"
        class="mt-1"
      ></b-skeleton>
      <b-skeleton type="button" height="22px" width="55px"></b-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleCardSkeleton",
  props: ["index"]
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wrapper {
  width: 100%;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  user-select: none;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  }
  .level {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    color: #a1b1ba;
    margin-bottom: 4px;
    user-select: none;
  }
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #474d52;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .details {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .ico {
        margin-right: 8px;
      }
    }
    .read {
      display: flex;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
      margin-right: 8px;
      margin-top: 2px;
    }
    .ico-bookmark {
      margin-right: 8px;
      cursor: pointer;
      &:hover {
        transform: scale(1.07);
      }
    }
    .ico-share {
      cursor: pointer;
      position: relative;
      svg {
        &:hover {
          transform: scale(1.07);
        }
      }
      &:active {
        transform: none;
      }
      .share-popup {
        position: absolute;
        width: 150px;
        height: 45px;
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        top: 100%;
        left: 80%;
        z-index: 3;
        &:hover {
          transform: none;
        }
      }
    }
  }
  .profile-badge {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    user-select: none;
    grid-column-gap: 8px;
    img {
      height: 32px;
      width: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
    .name {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 26px;
      color: #474d52;
      margin: 0;
    }
    .btn-follow {
      z-index: 0;
      border: 1px solid #474d52;
      box-sizing: border-box;
      border-radius: 4px;
      width: 54px;
      height: 20px;
      padding: 0px;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;
      transition: 0.2s ease;
      &:hover {
        background-color: #474d52;
        color: #fff;
        &:after,
        &:before {
          content: none;
        }
      }
    }
    .followed {
      width: 65px;
      color: #fff;
      background: #474d52;
    }
  }
}
</style>
